import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { ButtonContinue } from '../../common/Button/ButtonContinue';
import { capitalizeFirstLetter } from '../../common/HelperMethods';

type MobiliseWelcomeDialogProps = {
  showDialog: boolean;
  onCloseModal: () => void;
  brand: string;
};

const MobiliseWelcomeDialog = ({
  showDialog,
  onCloseModal,
  brand
}: MobiliseWelcomeDialogProps): JSX.Element => {
  const modalClass = 'modal-dialog-' + brand;

  return (
    <Modal
      role={modalClass}
      className={`insurance-${brand}`}
      isOpen={showDialog}
      toggle={onCloseModal}>
      <ModalHeader toggle={onCloseModal}>
        Welcome to {brand} Insurance
      </ModalHeader>
      <ModalBody>
        <p>
          {capitalizeFirstLetter(brand)} insurance is arranged by Car Care Plan
          Limited, which is authorised and regulated by the Financial Conduct
          Authority No. 309268 and our use of your data is governed by our Fair
          Use Notice and Terms of Business.
        </p>
      </ModalBody>
      <ModalFooter>
        <ButtonContinue
          name='modal-btn-continue'
          text='Continue'
          onClick={onCloseModal}
          additionalClassNames='btn-ok'
        />
      </ModalFooter>
    </Modal>
  );
};

export default MobiliseWelcomeDialog;
